import React from "react";
import { XCircleIcon, CheckCircleIcon } from "@heroicons/react/24/solid";

const ServiceConfiguratorBlockExpressionHeader = ({ validation, title }) => {
  return (
    <div className="flex justify-between">
      <div>
        <h3 className="capitalize text-xl">{title}</h3>
      </div>
      <div>
        {validation !== null ? (
          <div className="w-8 h-8">
            {validation ? (
              <div className="text-green-400">
                <CheckCircleIcon />
              </div>
            ) : (
              <div className="text-red-400">
                <XCircleIcon />
              </div>
            )}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ServiceConfiguratorBlockExpressionHeader;
